import Landing from "./Landing";

const LandingPage = () => {
  return (
    <>
      <Landing />
    </>
  );
};

export default LandingPage;
